/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalSubmissionListEntryTimExecutionPayor
 */
export interface PalSubmissionListEntryTimExecutionPayor {
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryTimExecutionPayor
     */
    name?: string;
}

/**
 * Check if a given object implements the PalSubmissionListEntryTimExecutionPayor interface.
 */
export function instanceOfPalSubmissionListEntryTimExecutionPayor(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalSubmissionListEntryTimExecutionPayorFromJSON(json: any): PalSubmissionListEntryTimExecutionPayor {
    return PalSubmissionListEntryTimExecutionPayorFromJSONTyped(json, false);
}

export function PalSubmissionListEntryTimExecutionPayorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryTimExecutionPayor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function PalSubmissionListEntryTimExecutionPayorToJSON(value?: PalSubmissionListEntryTimExecutionPayor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

